// extracted by mini-css-extract-plugin
export var noAccessLabelDarkMode = "ucLpf";